import Dinero from 'dinero.js';

export const formatCurrency = (
  inputAmount: number | string,
  currency: any = 'USD',
  precision: number = 3,
): string => {
  try {
    let amount: number;

    if (typeof inputAmount === 'string') {
      const floatAmount = parseFloat(inputAmount);
      if (isNaN(floatAmount)) throw Error;
      amount = Math.round(floatAmount * Math.pow(10, precision));
    } else {
      if (isNaN(inputAmount)) throw Error;
      amount = inputAmount;
    }

    return Dinero({
      amount,
      currency: currency.toUpperCase(),
      precision,
    }).toFormat('$0,0.00');
  } catch (e) {
    return '';
  }
};
